import { apiFetch } from '@app/utils/utils';
import { AdminAd } from '@app/Moderation/types';

const BASE = '/api/admin/ads';

export async function getAds(opts: {
  state?: string;
  type?: string;
  q?: string;
  limit?: number;
  offset?: number;
} = {}): Promise<AdminAd[]> {
  const params = new URLSearchParams();
  if (opts.state) params.set('state', opts.state);
  if (opts.type) params.set('type', opts.type);
  if (opts.q) params.set('q', opts.q);
  if (opts.limit != null) params.set('limit', String(opts.limit));
  if (opts.offset != null) params.set('offset', String(opts.offset));
  const qs = params.toString();
  const res = await apiFetch(`${BASE}${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error(`Failed to load ads (${res.status})`);
  return res.json();
}

export async function moderateAd(
  adId: number,
  decision: 'APPROVE' | 'REJECT',
  note?: string
): Promise<{ adId: number; adState: string }> {
  const res = await apiFetch(`${BASE}/${adId}/moderate`, {
    method: 'POST',
    body: JSON.stringify({ decision, note: note || null })
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Failed to moderate ad (${res.status})`);
  }
  return res.json();
}
